module.exports = __webpack_public_path__ + "static/4.0_550x380_Excerise_Desktop_1X-3a6b643c05c9c346c93360de3a39521a.png";